import React from 'react'

import ResidentAuthLayout from '@Components/atoms/ResidentAuthLayout'
import ResidentAuthVerification from '@Components/atoms/ResidentAuthVerification'
import ResidentAuthHeader from '@Components/atoms/ResidentAuthHeader'
import FloatingButton from '@Components/atoms/FloatingButton'
import useAuthentication from '@Hooks/myhouse/useAuthentication'
import InsuranceLayout from '@Components/atoms/InsuranceLayout'

type Props = {
  onPrevClick: (evt: React.SyntheticEvent) => void
  onCloseClick: (evt: React.SyntheticEvent) => void
  onAuthClick: (event: React.MouseEvent<HTMLButtonElement>) => void
  // authApplyNotifyYn: boolean
  // setAuthApplyNotifyYn: (value: boolean) => void
}

const ResidentAuthVerificationPage = ({ onPrevClick, onCloseClick, onAuthClick }: Props) => {
  const { authentication, setAuthApplyNotifyYn } = useAuthentication()
  const { authApplyNotifyYn } = authentication

  const checked = authApplyNotifyYn === 'Y'
  const setChecked = (value: boolean) => {
    setAuthApplyNotifyYn(value ? 'Y' : 'N')
  }

  return (
    <ResidentAuthLayout>
      <ResidentAuthHeader onPrevClick={onPrevClick} onCloseClick={onCloseClick} />
      <InsuranceLayout>
        <ResidentAuthVerification checked={checked} setChecked={setChecked} />
        <FloatingButton>
          <FloatingButton.GreenButton label="집주인 인증 신청하기" onClick={onAuthClick} />
        </FloatingButton>
      </InsuranceLayout>
    </ResidentAuthLayout>
  )
}

export default ResidentAuthVerificationPage
